<template>
    <div style="position: relative; width:auto;">
        <input type="text"  ref="mydivref" v-model="bairro">
        <div  class="autocomplete-bairros" v-if="mostrar">
            <div v-for="(b, index) in this.filtrado" :key="index">
                <p @click="() => onSelect(b.Nome)">{{ b.Nome }}</p>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "BairrosAutocomplete",
    props: {
        listaCompleta: Array,
        bairroDoViaCep: String,
    },
    data() {
        return {
            typed: "",
            bairro: null,
            mostrar: false,
            validou: false,
            filtrado: [],
        };
    },
    watch:{
        typed(v) {
            this.onType(v);
            if (v != null && v.length > 0) {
                this.mostrar = true
            } else {
                this.mostrar = false
            }
        },
    },
    created() {
        this.criar()
        this.verificarSeBairroExisteNaLista(this.bairroDoViaCep, this.listaCompleta)
    },
    methods: {
        criar() {
            setTimeout(() => {
                //Caso o input esteja vazio
                if (!this.$refs.mydivref) {
                    return
                }
                this.$refs.mydivref.addEventListener("input", (e) => {
                    let val = e.target.value
                    if (val.length > 0) {
                        this.mostrar = true
                        this.onType(val)
                    } else {
                        this.mostrar = false
                    }
                })
            }, 500);
        },
        onClick() {
            this.mostrar = !this.mostrar;
        },
        onType(val) {
            if (val == null || val.length == 0) {
                this.filtrado = []
            } else {
                this.filtrado = this.listaCompleta.filter((f) => f.Nome != null && f.Nome.toLowerCase().includes(val.toLowerCase()))
            }
            this.$emit('validou', false)
        },
        onSelect(selected) {
            console.log("selecionou", selected)
            this.bairro = selected
            this.typed = selected
            this.$refs.mydivref.value = selected
            setTimeout(() => {
                this.mostrar = false
                this.$emit('validou', true)
            }, 100);
            this.$emit('onSelect', selected)
            
        },
        verificarSeBairroExisteNaLista(bairro, listaBairros) {
            if(bairro){
                // normalizar deixa os nomes iguais para comparação(Ex Capão Raso e Capao Raso ficam CAPAO RASO)
                const normalizar = str => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
                // console.log("vamos verificar aqui:",normalizar(bairro))
                // console.log(listaBairros)82810690
                for (let b of listaBairros) {
                    if (b.Nome!= null && normalizar(b.Nome) === normalizar(bairro)) {
                        this.bairro = b.Nome;
                        this.validou = true
                        this.$emit('validou', true)
                        this.$emit('onSelect', b.Nome)
                        console.log("o bairro existe e foi selecionado",b.Nome)
                        break;
                    }
                }
            }
        }
    },
}
</script>

<style scoped>
.autocomplete-bairros {
    position: absolute;
    background: white;
    color: black;
    padding: 10px;
    right: 0px;
    left: 0;
    z-index: 50;
    /* height: 100px; */
}

.autocomplete-bairros p {
    padding-block: 5px;
}

</style>
